export const GET_ABSENCE_REASONS = 'GET_ABSENCE_REASONS'
export const GET_MISSED_LESSONS = 'GET_MISSED_LESSONS'
export const GET_STUDENTS = 'GET_STUDENTS'
export const GET_ABSENCE_REASON_BY_ID = 'GET_ABSENCE_REASON_BY_ID'
export const CLEAR_ABSENCE_REASON = 'CLEAR_ABSENCE_REASON'
